import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { PortalTicketCreateFlow } from "@sd/components/DarkThemeWidget/PortalTicketCreateFlow";
import { TicketDialogBackdrop, preventTicketDialogDismiss, ticketDialogOpenChangeHandler } from "@sd/components/tickets/TicketDialogBackdrop";
import "@sd/components/DarkThemeWidget/styles.css";

interface PortalTicketEditDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  ticketId: string | null;
  onUpdated?: () => void;
  modal?: boolean;
}

export function PortalTicketEditDialog({
  open,
  onOpenChange,
  ticketId,
  onUpdated,
  modal = false,
}: PortalTicketEditDialogProps) {
  const [flowKey, setFlowKey] = useState(0);

  useEffect(() => {
    if (open && ticketId) {
      setFlowKey(k => k + 1);
    }
  }, [open, ticketId]);

  return (
    <Dialog
      open={open}
      onOpenChange={ticketDialogOpenChangeHandler(onOpenChange)}
      modal={modal}
    >
      <TicketDialogBackdrop open={open} />
      <DialogContent
        hideOverlay
        {...preventTicketDialogDismiss()}
        className="z-50 flex max-h-[min(92vh,920px)] w-[min(720px,calc(100vw-2rem))] max-w-[720px] flex-col gap-0 overflow-hidden border-border p-0 sm:max-w-[720px] [&>button.absolute]:hidden"
      >
        <DialogHeader className="sr-only">
          <DialogTitle>Edit Ticket</DialogTitle>
          <DialogDescription>Update ticket details.</DialogDescription>
        </DialogHeader>

        {open && ticketId ? (
          <PortalTicketCreateFlow
            key={flowKey}
            embedded
            skipRequesterStep
            agentTheme
            skipSuccessScreen
            editTicketId={ticketId}
            onClose={() => onOpenChange(false)}
            onSuccess={() => onUpdated?.()}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
